import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { translations, type TranslationKey } from '../data/translations';
export type Language = 'en' | 'th';
interface LanguageContextValue {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: TranslationKey, vars?: Record<string, string | number>) => string;
}
const LanguageContext = createContext<LanguageContextValue | null>(null);
interface LanguageProviderProps {
  initialLanguage: Language;
  children: React.ReactNode;
}
export function LanguageProvider({
  initialLanguage,
  children
}: LanguageProviderProps) {
  const [lang, setLang] = useState<Language>(initialLanguage);
  useEffect(() => setLang(initialLanguage), [initialLanguage]);
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useCallback((key: TranslationKey, vars?: Record<string, string | number>) => {
    let text: string = translations[key][lang];
    if (vars) Object.entries(vars).forEach(([k, v]) => text = text.replace(`{${k}}`, String(v)));
    return text;
  }, [lang]);
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-868" data-mp="3cxheo18rwix5">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageContextValue {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside LanguageProvider');
  return ctx;
}